import React from 'react';
import styled from 'styled-components';
import CompanyLinks from './company-links';
import DiscoverLinks from './discover-links';
import LogoAndCopyright from './logo-and-copyright';
import ProductLinks from './product-links';
import ResourcesLinks from './resources-links';
import SatelliteImageryLinks from './satellite-links';

const Footer = () => {
    return (
        <Container>
            <Left>
                <LogoAndCopyright />
            </Left>
            <Right>
                <SitemapRow>
                    <SitemapColumn>
                        <SitemapHeader>Discover</SitemapHeader>
                        <DiscoverLinks />
                    </SitemapColumn>

                    <SitemapColumn>
                        <SitemapHeader>Satellites</SitemapHeader>
                        <SatelliteImageryLinks />
                    </SitemapColumn>

                    <SitemapColumn>
                        <SitemapHeader>Product</SitemapHeader>
                        <ProductLinks />
                    </SitemapColumn>

                    <SitemapColumn>
                        <SitemapHeader>Resources</SitemapHeader>
                        <ResourcesLinks />
                    </SitemapColumn>

                    <SitemapColumn>
                        <SitemapHeader>Company</SitemapHeader>
                        <CompanyLinks />
                    </SitemapColumn>
                </SitemapRow>
            </Right>
        </Container>
    );
};

export default Footer;

const Container = styled.div`
    height: 480px;
    padding: 140px 30px 30px 30px;
    text-align: center;
    display: flex;
    flex-direction: row;
    margin: 0 auto;
    width: 100%;

    @media only screen and (max-width: 1280px) {
        padding: 50px 30px 30px 30px;
        height: auto;
    }

    @media only screen and (max-width: 600px) {
        padding: 30px;
        flex-direction: column;
    }
`;

const Left = styled.div`
    width: 20%;

    @media only screen and (max-width: 600px) {
        width: 100%;
    }
`;

const Right = styled.div`
    width: 80%;
    padding: 0 0 0 50px;
    display: flex;
    flex-direction: column;

    @media only screen and (max-width: 600px) {
        padding: 0;
    }
`;

const SitemapRow = styled.div`
    width: 100%;
    height: 50%;
    display: flex;
    flex-direction: row;

    @media only screen and (max-width: 600px) {
        flex-direction: column;
    }
`;

const SitemapColumn = styled.div`
    width: 20%;
    height: 100%;

    @media only screen and (max-width: 600px) {
        width: 100%;
        display: flex;
        flex-direction: column;
    }
`;

const SitemapHeader = styled.h6`
    color: white;
    font-size: 1.1rem;
    text-decoration: none;
    font-weight: 600;
    text-align: left;
`;

export const SitemapLink = styled.button`
    color: white;
    text-decoration: none;
    text-align: left;
    font-size: 1rem;
    display: block;
    box-sizing: content-box;
    perspective-origin: 0 0;
    background: none !important;
    border: none;
    padding: 0 !important;
    cursor: pointer;

    &:focus {
        outline: thin dotted;
    }

    &:hover {
        text-decoration: none;
        color: #edd946;
    }
`;
